import {
    Editor,
    Element,
    Transforms,
} from "slate";
import {CustomElementType, CustomTextAttributeName} from "./custom-types";

export type EditorWithStyles = {
    isBold: () => boolean
    toggleBold: () => void
    isItalic: () => boolean
    toggleItalic: () => void
    isUnderline: () => boolean
    toggleUnderline: () => void
    getSelectedElement: () => Element | undefined
    setElementType: (t: CustomElementType) => void
}

const isMarkActive = (editor: Editor, mark: CustomTextAttributeName) => {
    const marks = Editor.marks(editor)
    return marks ? marks[mark] === true : false
}

const toggleMark = (editor: Editor, mark: CustomTextAttributeName) => {
    const isActive = isMarkActive(editor, mark)
    if (isActive) {
        Editor.removeMark(editor, mark)
    } else {
        Editor.addMark(editor, mark, true)
    }
}

const withStyles = (editor: Editor): Editor => {
    editor.isBold = () => isMarkActive(editor, 'bold')
    editor.toggleBold = () => toggleMark(editor, 'bold')
    editor.isItalic = () => isMarkActive(editor, 'italic')
    editor.toggleItalic = () => toggleMark(editor, 'italic')
    editor.isUnderline = () => isMarkActive(editor, 'underline')
    editor.toggleUnderline = () => toggleMark(editor, 'underline')
    editor.getSelectedElement = (): Element | undefined => {
        const { selection } = editor
        if (!selection) {
            return undefined
        }
        const [match] = Array.from(
            Editor.nodes(editor, {
                at: Editor.unhangRange(editor, selection),
                match: (node): node is Element => Element.isElement(node)
            })
        )

        return match ? match[0] : undefined
    }
    editor.setElementType = (t: CustomElementType) => {
        Transforms.setNodes<Element>(editor, {
            type: t,
        })
    }

    return editor
}

export default withStyles
